import { createAction, props } from '@ngrx/store';
import { IBillingTransactions } from '@dch/billing-business-logic';

export const GET_BILLING_TRANSACTIONS_REQUEST =
  'GET_BILLING_TRANSACTIONS_REQUEST';
export const GET_BILLING_TRANSACTIONS_SUCCESS =
  'GET_BILLING_TRANSACTIONS_SUCCESS';
export const GET_BILLING_TRANSACTIONS_FAILURE =
  'GET_BILLING_TRANSACTIONS_FAILURE';

export const getBillingTransactionsRequest = createAction(
  GET_BILLING_TRANSACTIONS_REQUEST,
  (billingAccountNumber: string) => ({
    billingAccountNumber,
  })
);

export const getBillingTransactionsSuccess = createAction(
  GET_BILLING_TRANSACTIONS_SUCCESS,
  props<{ billingAccountNumber: string; transactions: IBillingTransactions }>()
);

export const getBillingTransactionsFailure = createAction(
  GET_BILLING_TRANSACTIONS_FAILURE,
  props<{ billingAccountNumber: string }>()
);
